import React, { useEffect, useState } from 'react';
import { array, bool, string } from 'prop-types';

import MaterialTable from 'material-table';

import { TablePagination } from '@material-ui/core';

import classes from './RuleTargetsTable.module.css';

const RuleTargetsTable = ({
    error,
    isLoading,
    meta,
    onPageSet,
    onPageSizeSet,
    page,
    pageSize,
    targets,
    ...props
}) => {

    const [totalCount, setTotalCount] = useState();

    useEffect(() => {
        if (meta.totalCount && meta.totalCount !== totalCount) {
            setTotalCount(meta.totalCount);
        }
    }, [meta]);

    const handlePageChange = (event, page) => {
        onPageSet(page);
    };

    const handlePageSizeChange = event => {
        const { value } = event.target;

        onPageSizeSet(value);
    };

    if (!totalCount) return null;

    return (
        <div className={classes.RuleTargetsTable}>
            <MaterialTable
                options={{
                    paging:              true,
                    showTitle:           false,
                    search:              false,
                    selection:           false,
                    toolbar:             false,
                    sorting:             true,
                    headerStyle:         { position: 'sticky', top: 0 },
                    maxBodyHeight:       '50rem',
                    emptyRowsWhenPaging: false,
                    pageSize
                }}
                columns={[
                    {
                        title: 'Client Name',
                        field: 'clientName'
                    },
                    {
                        title: 'Site Name',
                        field: 'siteName'
                    },
                    {
                        title: 'Target Name',
                        field: 'systemEquipmentName'
                    }
                ]}
                data={targets}
                isLoading={isLoading}
                components={{
                    Pagination: props => {
                        return (
                            <TablePagination
                                {...props}
                                count={totalCount}
                                page={targets.length ? page : 0}
                                rowsPerPage={pageSize}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={event => { props.onChangeRowsPerPage(event); handlePageSizeChange(event); } }
                            />
                        );
                    }
                }}
            />
        </div>
    );
};

RuleTargetsTable.defaultProps = {
    error:     '',
    isLoading: false,
    targets:   []
};

RuleTargetsTable.propTypes = {
    error:     string,
    isLoading: bool,
    targets:   array
};

export default RuleTargetsTable;
